import React, { CSSProperties, ReactElement } from "react";

import { Button, Modal } from "semantic-ui-react";

import { useIntl } from "react-intl";

type ModInfoOAProps = {
  style?: CSSProperties;
  apiErrors?: Record<string, string[]>;
  btnStyle?: CSSProperties;
  btnText?: string;
  isLoading?: boolean;
  open: boolean;
  subtitle?: ReactElement | string;
  type?: "error" | "success";
  onApprove?: () => void;
  onClose: () => void;
};

type Styles = Record<"buttonContainer" | "container" | "primaryButton" | "subtitle", CSSProperties>;

const styles: Styles = {
  buttonContainer: {
    display: "flex",
    gap: "12px",
    marginTop: "1rem",
    width: "100%",
  },
  container: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    minWidth: "400px",
    padding: "3rem 2.5rem", // ใช้ padding เดียวกับ ModConfirm
    textAlign: "center",
  },
  primaryButton: {
    backgroundColor: "var(--primary-theme-color)",
    borderRadius: "8px",
    color: "white",
    fontSize: "16px",
    margin: "auto",
    minWidth: "15rem",
    padding: "12px 24px",
  },
  subtitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    width: "100%"
  },
};

const IMAGES = {
  error: "/static/images/landing/error-icon.png",
  success: "/static/images/landing/success-icon.png",
};

const ModInfoOA: React.FC<ModInfoOAProps> = (props) => {
  const intl = useIntl();

  return (
    <Modal
      style={{ borderRadius: "22px", width: "auto" }}
      open={props.open}
      closeOnDimmerClick
      onClose={props.onClose}
    >
      <div style={{ ...styles.container, ...props.style }}>
        <img
          style={{ marginBottom: "0.5rem", width: "70px" }}
          alt="success.icon"
          src={props.type === "error" ? IMAGES.error : IMAGES.success}
        />

        <h2
          style={{
            ...styles.subtitle,
            color: props.type === "error" ? "#585858" : "var(--primary-theme-color)",
          }}
        >
          {props.type === "error"
            ? props.subtitle ?? intl.formatMessage({ id: "บันทึกไม่สำเร็จ" })
            : props.subtitle ?? intl.formatMessage({ id: "บันทึกสำเร็จ" })}
        </h2>
        {props.apiErrors &&
          Object.values(props.apiErrors)
            .flat()
            .map((message, index) => (
              <div
                key={index}
                style={{ fontSize: "1.5rem", marginBottom: "1rem", marginTop: "-1rem" }}
              >
                {message}
              </div>
            ))}
        <div style={styles.buttonContainer}>
          <Button
            style={{ ...styles.primaryButton, ...props.btnStyle }}
            loading={props.isLoading}
            onClick={props.onApprove}
          >
            {props.btnText || intl.formatMessage({ id: "ตกลง" })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModInfoOA;
